import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ErrorMessages } from '@types';
import {
  parseZodErrors,
  scrollTop,
  TextAreaFlexibleLengthSchema,
} from '@utils';
import { ZodError } from 'zod';
import { useDrainsStore } from '../../../../hooks/useDrainsStore';
import { RoutesList } from '../../../../routes/Routes';
import { TEXT_AREA_MAX_LENGTH } from '@constants';

export const LocationAdditionalInformation = () => {
  const {
    data: { issueLocationMoreInfo },
    update,
  } = useDrainsStore();
  const [textInput, setTextInput] = useState(issueLocationMoreInfo);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();

  const pageTitle = 'Tell us more about the location of the issue';
  const description =
    "Include landmarks and buildings, for example, outside the telephone box opposite McDonald's.";
  const errorPath = 'tellUsMoreText';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      setErrorMessages([]);
      try {
        const validation = {
          fieldNames: ['tellUsMoreText'],
          maxLength: TEXT_AREA_MAX_LENGTH,
          minLength: 1,
          minLengthMessage: 'Enter details about the location of the issue',
          maxLengthMessage:
            'Details about the location of the issue must be 500 characters or less',
        };
        TextAreaFlexibleLengthSchema(validation).parse({
          tellUsMoreText: textInput,
        });
        update('issueLocationMoreInfo', textInput);
        navigate(RoutesList.EMAIL_CONFIRMATION);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ISSUE_LOCATION);
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={TEXT_AREA_MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
